import React from 'react';
import PropTypes from 'prop-types';
import {TAB_STATE} from '../ResultComparison.constants';
import { LogEvent } from '@learningblocks/shared-components/';
import './style.scss';

/**
 * ComparisonTabs:
 *  - Renders the comparison tabs [Predicted, Actual, Ideal]
 */
export function ComparisonTabs(props) {
  const renderTab = (tab) => (
      <Tab
        tabList={props.tabList}
        key={tab.value}
        label={tab.label}
        className='comparsionTabs_item'
        value={tab.value}
        onClick={props.selectTab}
      />
  );

  const renderTabList = () => props.tabList.map(renderTab);

  const setWrapperClass = () => {
    const activeTabs = props.tabList
      .reduce(
        (list, tab) =>
          tab.state != TAB_STATE.TERITARY ? [...list, tab.value] : list,
        []
      )
      .join('_');
    return `comparsionTabs comparsionTabs-${activeTabs}`;
  };

  return <div className={setWrapperClass()}>{renderTabList()}</div>;
}

ComparisonTabs.propTypes = {
  /**
   * List of tabs to be displayed
   */
  tabList: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       *The label of the tab
       */
      label: PropTypes.string,
      /**
       * Unique Id to recognize the tab
       */
      value: PropTypes.string,
      /**
       * state of the tab
       */
      state: PropTypes.oneOf([
        TAB_STATE.TERITARY,
        TAB_STATE.SECONDARY,
        TAB_STATE.PRIMARY,
      ]),
    })
  ),
  /**
   * Callback function to invoke when a tab is selected
   */
  selectTab: PropTypes.func,
};

ComparisonTabs.defultProps = {
  tabList: [],
};

function Tab(props) {
  const onClick = () => props.onClick(props.value);

  const setTabAriaLabel = () => {
    let ariaLabel = `${props.label} results. These are your ${props.label} results. `;
    if (props.ariaLabel && Object.keys(props.ariaLabel).length !== 0) {
      props.ariaLabel.forEach((data) => {
        ariaLabel = ariaLabel + '' + data.ariaLabel + ',';
      });
    }
    return ariaLabel;
  };

  return (
    <div className={props.className}>
      <LogEvent
        logEventProps={{
          event_type: "sim_results_tabs opened",
          event_schema: "tabs",
          tab_names: [
            props.tabList.find(
              listItem => listItem.state === "primary"
            ).value,
            props.value
          ]
        }}
        actionProps={{ onClick: { action: 'click' } }}
        elementType="button"
      >
        <div onClick={onClick}><h5>{props.label}</h5></div>
      </LogEvent>
    </div>
  );
}

Tab.propTypes = {
  /**
   * ClassName to be set for the tab
   */
  className: PropTypes.string,
  /**
   *The label of the tab
   */
  label: PropTypes.string,
  /**
   * Unique Id to recognize the tab
   */
  value: PropTypes.string,
  /**
   * Function to invoke when clicked
   */
  onClick: PropTypes.func,
};
